import { render } from "./deactivate-button.vue?vue&type=template&id=7efb7b18&lang=pug"
import script from "./deactivate-button.vue?vue&type=script&lang=js"
export * from "./deactivate-button.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__